function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusIcon = function SvgPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 11h4v2h-4v4h-2v-4H7v-2h4V7h2Zm9 1A10 10 0 1 1 12 2a10 10 0 0 1 10 10Zm-2 0a8 8 0 1 0-8 8 8 8 0 0 0 8-8Z",
    style: {
      fill: "#abb0c4"
    }
  }));
};
export default SvgPlusIcon;